import { useMemo } from "react";

import Timestamp from "components/Timestamp";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Blueprint } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { makeTimestampToCopy } from "ds/components/Table/helpers";

import useCellCopyAction from "../useCellCopyAction";
import { BLUEPRINTS_COLUMN_ID } from "../constants";

const BlueprintsTableUpdatedAtCell = ({
  item: blueprint,
  ...cellProps
}: TableSimpleCellProps<Blueprint>) => {
  const copyAction = useCellCopyAction({
    column: BLUEPRINTS_COLUMN_ID.UPDATED_AT,
    text: makeTimestampToCopy(blueprint.updatedAt),
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <Timestamp timestamp={blueprint.updatedAt} />
    </TableSimpleCell>
  );
};

export default BlueprintsTableUpdatedAtCell;
